import { useTranslation } from 'react-i18next'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { SectionTitle } from '../ui/SectionTitle'
import { motion } from 'framer-motion'
import { Award, Globe, Users, Settings } from 'lucide-react'

export function StrengthPoints() {
  const { t } = useTranslation()

  const strengths = [
    {
      key: 'experience',
      icon: Award,
    },
    {
      key: 'quality',
      icon: Settings,
    },
    {
      key: 'global',
      icon: Globe,
    },
    {
      key: 'flexibility',
      icon: Users,
    },
  ]

  return (
    <Section>
      <Container>
        <SectionTitle
          title={t('home.strengths.title')}
          subtitle={t('home.strengths.subtitle')}
          centered
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {strengths.map((strength, index) => (
            <motion.div
              key={strength.key}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="text-center p-6"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-primary/10 rounded-full flex items-center justify-center">
                <strength.icon className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-dark mb-2">
                {t(`home.strengths.${strength.key}.title`)}
              </h3>
              <p className="text-gray-600">
                {t(`home.strengths.${strength.key}.description`)}
              </p>
            </motion.div>
          ))}
        </div>
      </Container>
    </Section>
  )
}
